var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxtick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28_74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2398 30.5982H34.4337C33.5081 30.5982 32.7568 31.3273 32.7568 32.2257C32.7568 33.1241 33.5081 33.8532 34.4337 33.8532H57.2398C58.1654 33.8532 58.9167 33.1241 58.9167 32.2257C58.9167 31.3273 58.1654 30.5982 57.2398 30.5982ZM34.4337 19.5309H57.2398C58.1654 19.5309 58.9167 18.8018 58.9167 17.9034C58.9167 17.005 58.1654 16.2759 57.2398 16.2759H34.4337C33.5081 16.2759 32.7568 17.005 32.7568 17.9034C32.7568 18.8018 33.5081 19.5309 34.4337 19.5309ZM25.043 41.0144H22.36C19.9533 41.017 18.0027 42.9101 18 45.246V47.85C18.0027 50.1859 19.9533 52.079 22.36 52.0816H25.043C27.4497 52.079 29.4003 50.1859 29.403 47.85V45.246C29.4003 42.9101 27.4497 41.017 25.043 41.0144ZM26.0492 47.85C26.0492 48.3891 25.5984 48.8266 25.043 48.8266H22.36C21.8046 48.8266 21.3538 48.3891 21.3538 47.85V45.246C21.3538 44.7069 21.8046 44.2695 22.36 44.2695H25.043C25.5984 44.2695 26.0492 44.7069 26.0492 45.246V47.85ZM57.2398 44.9205H34.4337C33.5081 44.9205 32.7568 45.6496 32.7568 46.548C32.7568 47.4464 33.5081 48.1755 34.4337 48.1755H57.2398C58.1654 48.1755 58.9167 47.4464 58.9167 46.548C58.9167 45.6496 58.1654 44.9205 57.2398 44.9205ZM29.1723 26.8574L22.3023 34.1462L20.8588 32.7543C20.5556 32.4614 20.1384 32.2817 19.6769 32.2817C18.7513 32.2817 18 33.0095 18 33.9092C18 34.3597 18.1892 34.7686 18.495 35.0628L21.1781 37.6513L21.2076 37.6708L21.2277 37.6981C21.3257 37.7749 21.437 37.844 21.5577 37.8973L21.5671 37.9012C21.6181 37.9377 21.6771 37.9729 21.7388 38.0054L21.7469 38.0093C21.928 38.0822 22.1386 38.1239 22.36 38.1239C22.5947 38.1239 22.8174 38.0757 23.0187 37.9898L23.0079 37.9937C23.079 37.9533 23.1394 37.9143 23.1957 37.8713L23.1917 37.8739C23.3286 37.8088 23.4453 37.7307 23.5513 37.6408L23.5499 37.6421L23.57 37.6122L23.5969 37.594L31.646 29.054C31.9211 28.7649 32.0901 28.3769 32.0901 27.9511C32.0901 27.0527 31.3388 26.3236 30.4132 26.3236C29.9222 26.3236 29.4795 26.5293 29.1736 26.8561L29.1723 26.8574ZM29.1723 12.5351L22.3023 19.8239L20.8588 18.432C20.5556 18.1417 20.1397 17.962 19.6809 17.962C18.7553 17.962 18.004 18.6911 18.004 19.5895C18.004 20.0387 18.1918 20.4463 18.495 20.7405L21.1781 23.3276L21.2076 23.3472L21.2277 23.3745C21.3243 23.45 21.433 23.5164 21.5497 23.5698L21.5591 23.5737C21.6127 23.6115 21.6745 23.6492 21.7388 23.6831L21.7482 23.687C21.9293 23.7599 22.14 23.8016 22.36 23.8016C22.5947 23.8016 22.8174 23.7534 23.0187 23.6675L23.0079 23.6714C23.079 23.631 23.1394 23.592 23.1957 23.549L23.1917 23.5516C23.3286 23.4865 23.4453 23.4084 23.5513 23.3185L23.5499 23.3198L23.57 23.2899L23.5969 23.2717L31.646 14.7317C31.9224 14.4426 32.0914 14.0533 32.0914 13.6275C32.0914 12.7291 31.3402 12 30.4145 12C29.9222 12 29.4795 12.2057 29.1736 12.5338L29.1723 12.5351Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28_74",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_74",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxtick);
export default __webpack_public_path__ + "static/media/boxtick.1d2b2d09aafdfb7dd0b169490a554bb7.svg";
export { ForwardRef as ReactComponent };